import { testId } from '../../utils';
import { LinkButton } from './LinkButton';
import * as RadAccordion from '@radix-ui/react-accordion';
import React, { ReactNode } from 'react';

type ShowMoreProps = {
  title: ReactNode;
  content: ReactNode;
  'data-testid': string;
};

export const ShowMore = ({
  title,
  content,
  'data-testid': dataTestId,
}: ShowMoreProps) => (
  <RadAccordion.Root className="w-full" type="single" collapsible>
    <RadAccordion.Item value={'item-0'} {...testId(dataTestId)}>
      <RadAccordion.Trigger
        asChild
        className="bg-white flex justify-between transition-all group"
      >
        <LinkButton variant="no-underline" data-testid={'show-details-title'}>
          {title}
          <span className="material-symbols-outlined text-blue-active transition-transform duration-500 ease-in-out group-data-[state=closed]:rotate-180">
            expand_less
          </span>
        </LinkButton>
      </RadAccordion.Trigger>
      <RadAccordion.Content>{content}</RadAccordion.Content>
    </RadAccordion.Item>
  </RadAccordion.Root>
);
ShowMore.displayName = 'ShowMore';
